import { render, staticRenderFns } from "./trafficCardSharing.vue?vue&type=template&id=640faa23&"
import script from "./trafficCardSharing.vue?vue&type=script&lang=js&"
export * from "./trafficCardSharing.vue?vue&type=script&lang=js&"
import style0 from "./trafficCardSharing.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports